import React, { useState } from 'react'
 
 
import FinancialYearList from './FinancialYearList';
import FinancialYearForm from './FinancialYearForm';

const FinancialYear= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <FinancialYearForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <FinancialYearList addForm={setFromIsShown} update={setUpData} sId={setServiceId} />
        )}  
    </>
  )
}

export default FinancialYear